// extracted by mini-css-extract-plugin
module.exports = {"progressIcon":"SubmitButton_progressIcon__3grnq","wide":"SubmitButton_wide__HoaPv","underline":"SubmitButton_underline__3CtWP"};